import InlineWisetackDialog from './InlineWisetackDialog'

export * from './InlineWisetackDialog'
export default InlineWisetackDialog
